export class GroupAuthorization{
    unitType?: string;
    unitId?: number;
    authorizations?: string[];
}
export class GroupToSave{
    groupName?: string;
    groupAuthorizations?: GroupAuth[];
}

export class GroupAuth{
    unitType?: string;
    unitId?: number | null;
    authorizations?: string[];
}
export class Group{
    groupId?: number;
    groupName?: string;
    groupAuthorizations?: GroupAuth[];
}

export class GroupForGrid{
    groupId?: number;
    groupName?: string;
    groupAuthorizations?: string;
}

export class Groups{
    groups?: Group[];
}